
import React from 'react';
import FAQSection from '../content/FAQSection';
import CallToActionSection from '../content/CallToActionSection';

const SupportSections = () => {
  return (
    <>
      <FAQSection />
      <CallToActionSection />
    </>
  );
};

export default SupportSections;
